module.exports = __webpack_public_path__ + "static/media/caudillos-hugh-hamill.54054fe2.jpg";